<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'SPONSORS', pageCode: 'ALL', subPageCode: 'VIEW' }">
    <div class="grid mt-1 details-div border-200 mr-0">
        <div class="col-9 md:col-10  details-header-spacing">
            @if (showStatus) {
            <app-status [dataForVehicleStatus]="dataForVehicleStatus" [userId]="userId"
                [entityForStatus]="entityForStatus" [imgFileUrl]="" [imgFileId]="" [showImage]="false"></app-status>
            }
        </div>
        <div appAccessProvider [accessCode]="{ menuCode: 'SPONSORS', pageCode: 'ALL', subPageCode: 'EDIT' }"
            class="col-3 text-right flex align-items-center justify-content-end details-header-space">
            @if (isDeleted) {
            <button (click)="edit()" pButton
                class="edit-btn border-400 bg-white text-color mr-1 pl-2 pr-2 pt-1 pb-1 mr-2 hover:surface-100"
                [label]="editBtnLabel">
                <i class="mi-lg mr-2 edit-pen edit_pencil"></i>
            </button>
            }
        </div>
    </div>
    @if (dashboardCount) {
    <div class="flex pl-3 pr-3 pb-2 col-6">
        <div class="flex-1 mr-2">
            <p-card class="header-card cursor-pointer" (click)="activeIndexChange(1)">
                <div class="label" translate>sponsor.lbl_protocols</div>
                <div class="mt-1 text-2xl font-bold">{{protocolCount}}</div>
            </p-card>
        </div>

        <div class="flex-1 mr-2 ml-2">
            <p-card class="header-card cursor-pointer" (click)="activeIndexChange(2)">
                <div class="label" translate>sponsor.lbl_users</div>
                <div class="mt-1 text-2xl font-bold">{{userCount}}</div>
            </p-card>
        </div>
    </div>
    }
    <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true" (activeIndexChange)="activeIndexChange($event)"
        [scrollable]="true" class="vehicle-detail-tab">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg overview"></i>
                <label class="capitalize" translate>sponsor.lbl_overview</label>
            </ng-template>
            @if (sponsorDetails && sponsorAttributeData) {
            <app-sponsor-overview-details
                [attributeValues]="attributeValues"
                [attributeLabels]="attributeLabels"
                [sponsorAttributeData]="sponsorAttributeData"
                [vehicleEntityId]="vehicleId"
                [vehicleRowData]="currentRow"
                [sponsorDetails]="sponsorDetails"
                [driverList]="driverList"
                [isDeleted]="isDeleted"
                [isUnassigned]="isUnassigned"></app-sponsor-overview-details>
            }
        </p-tabPanel>

        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg mi-protocol_users"></i>
                <span class="capitalize">
                    <span translate>sponsor.lbl_protocols</span>
                    <span>({{protocolCount}})</span>
                </span>
            </ng-template>
            @if (activeIndex === 1) {
            <app-protocol-details (saveSuccess)="onEntityAdded()"
                [sponsorRelatedData]="sponsorRelatedData" />
            }
        </p-tabPanel>

        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg mi-sponsor_user"></i>
                <span class="capitalize">
                    <span translate>sponsor.lbl_users</span>
                    <span>({{userCount}})</span>
                </span>
            </ng-template>
            @if (activeIndex === 2) {
            <app-user-details (saveSuccess)="onEntityAdded()" />
            }
        </p-tabPanel>
    </p-tabView>
</div>